<template lang="pug">
  modal(@closeModal='closeModal')
    .column.center
      img.image.m4-bottom-8(src='../../assets/onboarding/il_Onboarding_Welcome.svg')
      h1.title-medium
        | {{ $t('onboarding.welcome') }}
      h2.text-xbig
        | {{ $t('onboarding.approaching') }}
      p.text-normal.text-center.m4-top-2.m4-bottom-9
        | {{ $t('onboarding.content') }}
      .row.space-between.buttons-container.width-100
        button.text-normal.link-button-blue(button='type' @click='closeModal')
          | {{ $t('onboarding.skipIntro') }}
        button.primary-button(button='type' @click='startOnboarding')
          | {{ $t('onboarding.knowKimple') }}
</template>

<script>
import { mapActions } from 'vuex'

import Modal from '../Modal'

import { feedOnboarding } from '../../utils/constants'

export default {
  components: { Modal },
  methods: {
    ...mapActions([
      'showElement',
      'hideElement',
      'setNavigationTutorialStatus'
    ]),
    async startOnboarding() {
      await this.setNavigationTutorialStatus(false)
      this.hideElement({ element: 'onboardingModal' })
      this.showElement({ element: 'onboarding' })
      this.$tours[feedOnboarding].start()
    },
    async closeModal() {
      await this.setNavigationTutorialStatus(false)
      this.hideElement({ element: 'onboardingModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables/colors';

.modal-container {
  padding: 48px 28px 28px;
  .buttons-container {
    border-top: 1px solid $light-gray;
    padding-top: 28px;
  }

  .image {
    height: 196px;
  }
}
</style>
